<template>
  <layout-view>
    <template v-slot:tabs>
      <v-tabs v-model="tab" background-color="transparent">
        <v-tab>Создать</v-tab>
        <v-tab>История</v-tab>
      </v-tabs>
    </template>
    <template v-slot:content="{height}">
      <div v-if="tab===0">
        <v-row no-gutters>
          <v-col cols="auto">
            <v-sheet width="350" color="transparent">
              <toolbar-view title="Настройка новой рассылки"/>
              <v-sheet class="overflow-y-auto" :height="height-48" color="transparent">
                <div class="pt-2 px-4">
                  <v-text-field v-model="name" label="Название" dense outlined hide-details="auto" clearable class="mb-4"/>

                  <v-textarea
                      v-model="text"
                      outlined dense auto-grow rows="1" hide-details class="mb-4"
                      :readonly="templateId!==null"
                  >
                    <template v-slot:label>
                      <div :class="templateId==null ? '' : 'pr-8'">Текст сообщения</div>
                    </template>
                    <template v-slot:prepend-inner>
                      <v-icon v-if="templateId!==null" class="ml-2 mt-1 mr-2" size="20">mdi-lock</v-icon>
                    </template>
                    <template v-slot:append>
                      <v-btn v-if="!$tools.isEmpty(text)" icon @click="text=null;templateId=null;textTags=[]"><v-icon size="20">mdi-close</v-icon></v-btn>
                    </template>
                  </v-textarea>
                  <chats-message-tags/>

                  <v-row class="rowSmall">
                    <v-col cols="12" class="caption pb-1">Дата / Время отправки</v-col>
                    <v-col><date :value.sync="sendDate" name="Дата"/></v-col>
                    <v-col><tim :value.sync="sendTime" name="Время"/></v-col>
                  </v-row>

                  <v-text-field
                      v-model="delay"
                      label="Задержка между сообщениями (сек.)"
                      type="number"
                      clearable
                      dense outlined hide-details="auto" class="mb-4"
                  />

                  <autocomplete-single
                      name="Отправить через"
                      :items="comContactState.data.items"
                      :select.sync="comContact"
                      :loading="comContactState.loading"
                  >
                    <template v-slot:selectedInfo="{item}">
                      <span>{{item.name}}</span>
                      <dot/>
                      <v-icon :color="item.info.messengerTypeIconBgColor" small>{{item.info.messengerTypeIcon}}</v-icon>
                      <span class="text-no-wrap ml-1">{{item.info.messengerTypeStr}}</span>
                      <dot/>
                      <span class="text-no-wrap">{{$tools.phoneFormat(item.phone)}}</span>
                    </template>
                    <template v-slot:itemInfo="{item}">
                      <div class="mt-1">
                        <v-icon :color="item.info.messengerTypeIconBgColor" small>{{item.info.messengerTypeIcon}}</v-icon>
                        <span class="text-no-wrap ml-1">{{item.info.messengerTypeStr}}</span>
                        <dot/>
                        <span class="text-no-wrap">{{$tools.phoneFormat(item.phone)}}</span>
                      </div>
                    </template>
                  </autocomplete-single>
                </div>
                <v-divider/>

                <div class="py-2 px-4">
                  <v-row no-gutters>
                    <v-col></v-col>
                    <v-col cols="auto">
                      <btn-small-accept
                          name="Создать рассылку" text="Вы уверены что хотите создать рассылку?"
                          :loading="createState.isLoading" color="primary"
                          :disabled="
                            $tools.isEmpty(name) ||
                            $tools.isEmpty(text) ||
                            $tools.isEmpty(delay) ||
                            $tools.isEmpty(sendDate) ||
                            $tools.isEmpty(sendTime) ||
                            $tools.isEmpty(comContact)
                          "
                          @accept="create()"
                      >
                        Создать рассылку
                        <template v-slot:footer="{isOpen}">
                          <v-btn text @click="isOpen(false);$emit('update:medRecordId', null);">Выйти без сохранения</v-btn>
                          <v-spacer/>
                          <v-btn text @click="isOpen(false);saveAction(false);$emit('update:medRecordId', null);" color="primary">Сохранить</v-btn>
                        </template>
                      </btn-small-accept>
                    </v-col>
                  </v-row>
                </div>
              </v-sheet>
            </v-sheet>
          </v-col>
          <v-col cols="auto">
            <v-divider vertical/>
          </v-col>
          <v-col cols="auto">
            <v-sheet width="350" class="overflow-auto" color="transparent">
              <chats-message-templates
                  :height="height"
                  :selectAllowed="true"
                  @select="(v)=>{
                    text = v.text;
                    templateId = v.id;
                    textTags = v.textTags;
                    preview();
                  }"
              />
            </v-sheet>
          </v-col>
          <v-col cols="auto">
            <v-divider vertical/>
          </v-col>
          <v-col>
            <toolbar-view :title="'Предосмотр (выбрано пользователей: '+usersSelects.length+')'"/>
            <div v-if="previewState.error">
              <alert>{{previewState.errorMessage}}</alert>
            </div>
            <v-data-table
                v-else
                class="table4"
                :headers="[
                { text: '', sortable:false},
                { text: 'ID', value: 'userId', class:'text-no-wrap', sortable:false},
                { text: 'Ф.И.О', value: 'userFullName', class:'text-no-wrap', sortable:false},
                { text: 'Текст', value: 'text', class:'text-wrap', sortable:false},
              ]"
                :items="previewState.data.items"
                :server-items-length="previewState.data.count"
                fixed-header
                :loading="previewState.loading"
                :height="height-48-48"
                :items-per-page="50"
                :options.sync="previewOptions"
                :footer-props="{'items-per-page-options': [50, 100, 500]}"
                dense
            >
              <template v-slot:item="{item}">
                <tr>
                  <td class="text-no-wrap">
                    <v-btn icon @click="removeUser(item)"><v-icon small>mdi-close</v-icon></v-btn>
                  </td>
                  <td class="text-no-wrap">{{item.id}}</td>
                  <td class="text-no-wrap"><user-full-name :user="item"/></td>
                  <td class="text-wrap">{{item.text}}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </div>
      <div v-if="tab===1">
        <distributes :height="height"/>
      </div>
    </template>
  </layout-view>
</template>

<script>

import LayoutView from "@/components/LayoutView.vue";
import {
  Entity_ComContact,
} from "../../../../EntityStoreCacheService";
import Stater from "@/plugins/stater";
import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import Dot from "@/componentsV2/base/Dot.vue";
import ChatsMessageTemplates from "@/views/ContactCenter/Messenger/components/ChatsMessageTemplates.vue";
import ToolbarView from "@/components/ToolbarView.vue";
import ChatsMessageTags from "@/views/ContactCenter/Messenger/components/ChatsMessageTags.vue";
import BtnSmallAccept from "@/componentsV2/base/BtnSmallAccept.vue";
import axios from "axios";
import Api from "@/Api";
import Alert from "@/componentsV2/base/Alert.vue";
import Date from "@/componentsV2/base/Date.vue";
import Tim from "@/componentsV2/base/Tim.vue";
import moment from "moment";
import Distributes from "@/views/ContactCenter/Messenger/Distributes.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";

export default {
  components: {
    UserFullName,
    Distributes,
    Date,
    Tim,
    Alert,
    BtnSmallAccept,
    ChatsMessageTags,
    ToolbarView, ChatsMessageTemplates, Dot, AutocompleteSingle, LayoutView
  },
  props: [],
  data: () => ({
    tab:0,
    name:null,
    text:null,
    textTags:[],
    templateId:null,

    comContactState:new Stater({items:[],count:0}),
    comContact:null,

    previewState:new Stater({items:[],count:0}),
    previewOptions:{},

    delay:15,
    sendDate:null,
    sendTime:null,
    createState:new Stater(),

    usersSelects:[],
  }),
  mounted() {
    this.usersSelects = this.$tools.storageGet('users_selects', []).map(v=>v.id);

    this.sendDate = moment().format('DD.MM.YYYY');
    this.sendTime = moment().format('HH:mm');
    this.load();
  },
  watch:{
    text(){this.preview()},
    comContact(){this.preview()},
    previewOptions(){
      this.preview();
    }
  },
  methods: {
    load(){
      new Entity_ComContact()
          .selects(Entity_ComContact.id)
          .selects(Entity_ComContact.name)
          .selects(Entity_ComContact.messengerType)
          .selects(Entity_ComContact.phone)
          .virtual(Entity_ComContact.virtual_info)
          .order(Entity_ComContact.messengerType, true)
          .addStateCallback((v) => this.comContactState.setRequestBuilderState(v))
          .request()
    },
    preview(){
      if(this.$tools.isEmpty(this.text))
        return;
      this.previewState.stateLoading();
      this.$tools.debounce(() => {
        axios.post(Api.host + '/messenger/distribute/preview/', {
          page: this.previewOptions.page,
          onPage: this.previewOptions.itemsPerPage,
          userIds: this.usersSelects,
          text: this.text,
          textTags: this.textTags,
        }).then((r) => {
          this.previewState.data = r.data;
          this.previewState.stateSuccess()
        }).catch(() => {
          this.previewState.stateError()
        });
      }, 1000);
    },
    create() {
      this.createState.stateLoading()
      axios.post(Api.host + '/messenger/distribute/', {
        name: this.name,
        userIds: this.usersSelects,
        text: this.text,
        textTags: this.textTags,
        templateId: this.templateId,
        delay: this.delay,
        sendDate: moment(this.sendDate+' '+this.sendTime, 'DD.MM.YYYY HH:mm').format('YYYY-MM-DD HH:mm:')+'00',
        comContactId: this.comContact.id,
      }).then(() => {
        this.createState.stateSuccess();
        this.name = null;
        this.text = null;
        this.textTags = [];
        this.templateId = null;
        this.delay = null;
        this.sendDate = null;
        this.sendTime = null;
        this.$store.commit('alertSuccess', 'Успешно создано');
      }).catch(() => {
        this.createState.stateError()
      });
    },
    removeUser(v){
      let usersSelects = this.$tools.storageGet('users_selects', [])
      this.$tools.selectToggle(usersSelects, v)
      this.$tools.storageSet('users_selects', usersSelects)
      this.usersSelects = this.$tools.storageGet('users_selects', []).map(v=>v.id);
      this.preview();
    }
  }
}
</script>